import React from "react";
import { useQuote } from "./QuoteDialog";

export default function Objection() {
  const { openQuote } = useQuote();
  return (
    <section
      data-testid="objection-section"
      className="bg-[#F4F6F4] py-24 md:py-32"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-16 text-center">
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
          We make it easy
        </div>
        <h2
          data-testid="objection-headline"
          className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
        >
          Not Sure What Your School Needs?
        </h2>
        <p className="mt-8 font-serif text-2xl sm:text-3xl text-navy italic">
          That's exactly why we're here.
        </p>
        <p className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed max-w-2xl mx-auto">
          Whether you're just exploring options or ready to move forward, we'll help you
          choose the right setup based on your goals, space, and budget.
        </p>
        <p className="mt-8 inline-block font-serif text-xl font-bold text-teal border-t border-b border-teal/30 py-2 px-6">
          No pressure. Just clarity.
        </p>
        <div className="mt-10">
          <button
            data-testid="objection-quote-btn"
            onClick={openQuote}
            className="bg-navy hover:bg-[#091638] text-white font-bold px-8 py-4 rounded-lg shadow-md hover:shadow-xl transition-all duration-200 hover:-translate-y-0.5"
          >
            Request a Quote
          </button>
        </div>
      </div>
    </section>
  );
}
